export const RIDDLED_IN_IMAGE_COST = 200;

